'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdCamera = function MdCamera(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.4 36.3c2.7-4.7 5.3-9.4 8.1-14l6 10.6c-2.8 2.3-6.5 3.7-10.5 3.7-1.2 0-2.4-0.1-3.6-0.3z m-12.3-11.3h16.1l-6.1 10.5c-4.8-1.7-8.5-5.7-10-10.5z m3.6-16.2c2.8 4.8 5.6 9.7 8.5 14.6h-12.5c-0.3-1.1-0.3-2.2-0.3-3.4 0-4.4 1.6-8.3 4.3-11.2z m28.6 7.8c0.3 1.1 0.3 2.2 0.3 3.4 0 4.4-1.6 8.3-4.3 11.3l-8-13.8-0.5-0.9h12.5z m-0.4-1.6h-16.1l6.1-10.5c4.8 1.8 8.5 5.7 10 10.5z m-20.2 2.5l-0.2 0.2-6-10.6c2.8-2.3 6.5-3.7 10.5-3.7 1.3 0 2.4 0.1 3.6 0.4z' })
        )
    );
};

exports.default = MdCamera;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/camera.js
// module id = 2154
// module chunks = 0